module.exports = __webpack_public_path__ + "img/close.f7777540.svg";